import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

export const biteProductApi = {
  getAll: () =>
    axiosClient.get(ENDPOINTS.biteProducts.list).then(unwrap),

  getActiveStockTracked: () =>
    axiosClient.get(ENDPOINTS.biteProducts.activeStockTracked).then(unwrap),

  create: (data) =>
    axiosClient.post(ENDPOINTS.biteProducts.create, data).then(unwrap),

  update: (id, data) =>
    axiosClient.put(ENDPOINTS.biteProducts.update(id), data).then(unwrap),

  setStatus: (id, status) =>
    axiosClient
      .patch(ENDPOINTS.biteProducts.status(id), null, {
        params: { status },
      })
      .then(unwrap),

  getOutletSettings: (biteProductId) =>
    axiosClient
      .get(ENDPOINTS.biteProducts.outletSettings(biteProductId))
      .then(unwrap),

  updateOutletSetting: (biteProductId, outletCode, request) =>
    axiosClient
      .put(
        ENDPOINTS.biteProducts.outletSetting(biteProductId, outletCode),
        request
      )
      .then(unwrap),

  uploadImage: (biteId, file) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosClient
      .post(
        `/api/admin/file-assets/product-images/restaurant/${biteId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then(unwrap);
  },

  removeImage: (biteId) =>
    axiosClient
      .delete(`/api/admin/file-assets/product-images/restaurant/${biteId}`)
      .then(unwrap),
};
